/* eslint-disable react/no-array-index-key */
import { twJoin } from 'tailwind-merge';

import Badge from 'molecules/Badge';
import Bullet from 'molecules/Bullet';
import Button from 'molecules/Button';

import { pricingCardSectionStyle, pricingCardTitleStyle } from 'organisms/Cards/Pricing/styles';

import Tooltip from 'components/Tooltip';

import { hasArrayValues } from 'utils/array/arrays';

import type { PricingCardConfigProps } from 'organisms/Cards/Pricing/config';
import type { FC } from 'react';

const openChiliPiperPopup = (url: string) => {
  const width = 600;
  const height = 700;
  const left = Math.round(window.screenX + (window.outerWidth - width) / 2);
  const top = Math.round(window.screenY + (window.outerHeight - height) / 2);
  window.open(url, 'chilipiper', `width=${width},height=${height},left=${left},top=${top}`);
};

const PricingCard: FC<PricingCardConfigProps> = ({
  planName,
  description,
  highlighted,
  details,
  label,
  href,
  startIcon,
  endIcon,
  chiliPiperUrl,
}) => (
  <div className={pricingCardSectionStyle({ isHighlighted: !!highlighted })}>
    <div className="flex flex-col gap-8">
      <div className="flex flex-col items-start justify-start gap-4">
        <div className="flex flex-row items-center gap-6">
          <h2 className={pricingCardTitleStyle({ isHighlighted: !!highlighted })}>{planName}</h2>
          {highlighted && (
            <div className="text-sm font-medium">
              <Badge label="Most Popular" color="teal" />
            </div>
          )}
        </div>
        <span className="text-left text-md text-gray-300">{description}</span>
      </div>
      <div className="flex flex-col gap-4">
        <span className="font-spaceGrotesk text-xl font-bold text-white">What&apos;s included:</span>
        <ul className="flex flex-col gap-4">
          {hasArrayValues(details) &&
            details.map((detail, idx) => (
              <Bullet key={idx}>
                {detail?.description ? (
                  <Tooltip label={detail?.description} delayDuration={300}>
                    <span className="w-fit text-left text-md text-gray-300">{detail?.detail}</span>
                  </Tooltip>
                ) : (
                  <span
                    className={twJoin(
                      detail?.description && 'border-b border-b-gray-300 border-dashed',
                      'text-left text-md text-gray-300 w-fit cursor-default',
                    )}
                  >
                    {detail?.detail}
                  </span>
                )}
              </Bullet>
            ))}
        </ul>
      </div>
    </div>
    <div className="w-full">
      <Button
        href={chiliPiperUrl ? undefined : href}
        onClick={chiliPiperUrl ? () => openChiliPiperPopup(chiliPiperUrl) : undefined}
        hierarchy={highlighted ? 'primary' : 'secondary'}
        startIcon={startIcon}
        endIcon={endIcon}
        className="w-full md:w-full lg:w-full"
      >
        {label || 'Contact Us'}
      </Button>
    </div>
  </div>
);

export default PricingCard;
